import { render, staticRenderFns } from "./SampleConfirmedBody.vue?vue&type=template&id=28f999e6&"
import script from "./SampleConfirmedBody.vue?vue&type=script&lang=js&"
export * from "./SampleConfirmedBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports